import { distanceSquared } from 'helpers/walls/snapToWall'

/**
 * Snaps a pixel coordinate to the closest map object if under the SNAP_DISTANCE threshold
 *
 * @param {Point} pixel - The pixel coordinates of the mouse to snap
 * @param {google.maps.MapCanvasProjection} projection - The coordinate to pixel projection currently used by the map
 * @param {Array} objects - Array of map objects with location prop
 * @return {google.maps.LatLng} Snapped location
 */

export default function snapToClosestObject(pixel, projection, objects) {
  const latlng = projection.fromContainerPixelToLatLng(pixel)
  let snappedObject
  let minDistance = Infinity
  let closestSegment = []

  objects.forEach(object => {
    const dist = distanceSquared(object.location.lat, object.location.lng, latlng.lat(), latlng.lng())

    if (dist < minDistance) {
      minDistance = dist
      snappedObject = object
    }
  })

  if (snappedObject) {
    const position = new google.maps.LatLng(snappedObject.location)
    const snappedPixel = projection.fromLatLngToContainerPixel(position)

    if (Math.sqrt(distanceSquared(snappedPixel.x, snappedPixel.y, pixel.x, pixel.y)) < SNAP_DISTANCE) {
      return { position, snappedObject }
    }
  }

  return { position: latlng, snappedObject: null }
}

/** Threshold for snapping */
const SNAP_DISTANCE = 30



// WEBPACK FOOTER //
// ./src/helpers/wires/snapToClosestObject.js